module.exports = __webpack_public_path__ + "static/media/frame-c-arrow-right-us.f03b8d34.svg";